/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { Form, Select, Card, Row, Col, Typography, Input, Spin, message } from 'antd';
import { BankOutlined, FileTextOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { banksAPI, organisationBanksAPI } from '../../../services/api';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

// Step 4: Bank Transfer
// - Loads bank names for sender & beneficiary orgs
// - After a bank is selected, loads its accounts for that org
// - Persists both the chosen account id and a human-readable display string
// - Restores prior selections when returning to this step
const Step4BankTransfer = ({ data, onDataChange }) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [senderBankNames, setSenderBankNames] = useState([]);
  const [beneficiaryBankNames, setBeneficiaryBankNames] = useState([]);
  const [selectedSenderBankId, setSelectedSenderBankId] = useState(null);
  const [selectedBeneficiaryBankId, setSelectedBeneficiaryBankId] = useState(null);
  const [senderBanks, setSenderBanks] = useState([]); // accounts filtered by selectedSenderBankId
  const [beneficiaryBanks, setBeneficiaryBanks] = useState([]); // accounts filtered by selectedBeneficiaryBankId

  useEffect(() => {
    // console.debug('Step4 data received:', data);
    if (data.sender_id && data.beneficiary_id) {
      loadBankNames();
    }
  }, [data.sender_id, data.beneficiary_id]);

  // When sender bank names load, restore previously selected bank if available; otherwise auto-select first
  useEffect(() => {
    const selectFirstSenderBank = async () => {
      // Restore previously selected bank if saved in data
      if (!selectedSenderBankId && data.sender_selected_bank_id) {
        setSelectedSenderBankId(data.sender_selected_bank_id);
        await loadBankAccountsFiltered('sender', data.sender_id, data.sender_selected_bank_id);
        // Ensure bank name is persisted if available
        const b = (senderBankNames || []).find(x => x.bank_id === data.sender_selected_bank_id);
        if (b && !data.sender_bank_name) {
          onDataChange({ ...data, sender_bank_name: b.bank_name_en || b.bank_name_ar });
        }
        return;
      }
      // Only auto-select a default bank if the user has not already selected an account
      if (!data.sender_bank_id && !selectedSenderBankId && senderBankNames.length > 0) {
        const first = senderBankNames[0];
        setSelectedSenderBankId(first.bank_id);
        await loadBankAccountsFiltered('sender', data.sender_id, first.bank_id);
        // Persist chosen bank meta (id + name)
        onDataChange({ 
          ...data, 
          sender_selected_bank_id: first.bank_id,
          sender_bank_name: first.bank_name_en || first.bank_name_ar
        });
      }
    };
    selectFirstSenderBank();
  }, [senderBankNames, selectedSenderBankId, data.sender_id, data.sender_bank_id, data.sender_selected_bank_id]);

  // When beneficiary bank names load, restore previously selected bank if available; otherwise auto-select first
  useEffect(() => {
    const selectFirstBeneficiaryBank = async () => {
      // Restore previously selected bank if saved in data
      if (!selectedBeneficiaryBankId && data.beneficiary_selected_bank_id) {
        setSelectedBeneficiaryBankId(data.beneficiary_selected_bank_id);
        await loadBankAccountsFiltered('beneficiary', data.beneficiary_id, data.beneficiary_selected_bank_id);
        // Ensure bank name is persisted if available
        const b = (beneficiaryBankNames || []).find(x => x.bank_id === data.beneficiary_selected_bank_id);
        if (b && !data.beneficiary_bank_name) {
          onDataChange({ ...data, beneficiary_bank_name: b.bank_name_en || b.bank_name_ar });
        }
        return;
      }
      // Only auto-select a default bank if the user has not already selected an account
      if (!data.beneficiary_bank_id && !selectedBeneficiaryBankId && beneficiaryBankNames.length > 0) {
        const first = beneficiaryBankNames[0];
        setSelectedBeneficiaryBankId(first.bank_id);
        await loadBankAccountsFiltered('beneficiary', data.beneficiary_id, first.bank_id);
        // Persist chosen bank meta (id + name)
        onDataChange({ 
          ...data, 
          beneficiary_selected_bank_id: first.bank_id,
          beneficiary_bank_name: first.bank_name_en || first.bank_name_ar
        });
      }
    };
    selectFirstBeneficiaryBank();
  }, [beneficiaryBankNames, selectedBeneficiaryBankId, data.beneficiary_id, data.beneficiary_bank_id, data.beneficiary_selected_bank_id]);

  // After accounts lists change, auto-select first accounts if not set
  useEffect(() => {
    const bankSelections = {};
    if (!data.sender_bank_id && senderBanks.length > 0) {
      const first = senderBanks[0];
      bankSelections.sender_bank_id = first.id;
      bankSelections.sender_selected_bank_id = first.bank_id;
      bankSelections.sender_bank_display = formatBankOption(first);
      if (!selectedSenderBankId) setSelectedSenderBankId(first.bank_id);
    }
    if (!data.beneficiary_bank_id && beneficiaryBanks.length > 0) {
      const first = beneficiaryBanks[0];
      bankSelections.beneficiary_bank_id = first.id;
      bankSelections.beneficiary_selected_bank_id = first.bank_id;
      bankSelections.beneficiary_bank_display = formatBankOption(first);
      if (!selectedBeneficiaryBankId) setSelectedBeneficiaryBankId(first.bank_id);
    }
    if (Object.keys(bankSelections).length > 0) {
      form.setFieldsValue(bankSelections);
      onDataChange({ ...data, ...bankSelections });
    }
  }, [senderBanks, beneficiaryBanks, data.sender_bank_id, data.beneficiary_bank_id, form, onDataChange, data]);

  useEffect(() => {
    // Update form when data changes
    form.setFieldsValue({
      sender_bank_id: data.sender_bank_id,
      beneficiary_bank_id: data.beneficiary_bank_id,
      notes: data.notes
    });
  }, [data.sender_bank_id, data.beneficiary_bank_id, data.notes, form]);

  const loadBankNames = async () => {
    try {
      setLoading(true);
      const [senderNamesRes, beneficiaryNamesRes] = await Promise.all([
        organisationBanksAPI.getBankNamesByOrganisation(data.sender_id),
        organisationBanksAPI.getBankNamesByOrganisation(data.beneficiary_id)
      ]);

      const senderNames = senderNamesRes?.data?.data?.banks || [];
      const beneficiaryNames = beneficiaryNamesRes?.data?.data?.banks || [];

      setSenderBankNames(Array.isArray(senderNames) ? senderNames : []);
      setBeneficiaryBankNames(Array.isArray(beneficiaryNames) ? beneficiaryNames : []);

      // console.debug('Loaded sender bank names:', senderNames);
      // console.debug('Loaded beneficiary bank names:', beneficiaryNames);

    } catch (error) {
      console.error('Error loading bank accounts:', error);
      message.error(intl.formatMessage({ id: 'settlement_FailedToLoadBankAccountsError' }) + (error.response?.data?.message || error.message));
      setSenderBankNames([]);
      setBeneficiaryBankNames([]);
    } finally {
      setLoading(false);
    }
  };

  const loadBankAccountsFiltered = async (type, orgId, bankId) => {
    try {
      setLoading(true);
      const res = await organisationBanksAPI.getByOrganisationAndBank(orgId, bankId);
      const accounts = res?.data?.data?.organisationBanks || [];
      if (type === 'sender') {
        setSenderBanks(accounts);
      } else {
        setBeneficiaryBanks(accounts);
      }
    } catch (error) {
      console.error('Error loading filtered bank accounts:', error);
      message.error(intl.formatMessage({ id: 'settlement_FailedToLoadBankAccountsError' }) + (error.response?.data?.message || error.message));
      if (type === 'sender') setSenderBanks([]);
      else setBeneficiaryBanks([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (changedFields, allFields) => {
    const formData = form.getFieldsValue();
    const updatedData = { ...data, ...formData };
    onDataChange(updatedData);
    // console.debug('Step4 form changed:', formData);
  };

  const validateForm = () => {
    const formValues = form.getFieldsValue();
    return formValues.sender_bank_id && formValues.beneficiary_bank_id;
  };

  const handleNext = () => {
    const formValues = form.getFieldsValue();
    // console.debug('Step4 handleNext - form values:', formValues);
    // console.debug('Step4 handleNext - current data:', data);
    
    // Manual validation
    if (!formValues.sender_bank_id) {
      message.error(intl.formatMessage({ id: 'settlement_PleaseSelectSenderBankAccount' }));
      return;
    }
    
    if (!formValues.beneficiary_bank_id) {
      message.error(intl.formatMessage({ id: 'settlement_PleaseSelectBeneficiaryBankAccount' }));
      return;
    }
    
    // Update data and proceed
    const updatedData = { ...data, ...formValues };
    onDataChange(updatedData);
    console.log('Step4 proceeding with final data:', updatedData);
    
    // Double-check the data was updated
    setTimeout(() => { 
      // console.debug('Step4 data after update:', data);
      onNext();
    }, 100);
  };

  const formatBankOption = (bank) => {
    return `${bank.account_number} (IBAN: ${bank.iban || 'N/A'})`;
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px' }}>{intl.formatMessage({ id: 'settlement_LoadingBankAccounts' })}</div>
      </div>
    );
  }

  return (
    <div className="step4-bank-transfer">
      <Card>
        <Title level={4}>
          <BankOutlined /> {intl.formatMessage({ id: 'settlement_BankTransferDetailsTitle' })}
        </Title>

        <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
          <Col xs={24} md={12}>
            <Card size="small">
              <Text strong>{intl.formatMessage({ id: 'settlement_SenderOurCompanyShort' })}</Text> {data.sender_name || ''}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card size="small">
              <Text strong>{intl.formatMessage({ id: 'settlement_BeneficiaryPTOShort' })}</Text> {data.beneficiary_name || ''}
            </Card>
          </Col>
        </Row>

        <Form
          form={form}
          layout="vertical"
          onValuesChange={handleFormChange}
          initialValues={{
            sender_bank_id: data.sender_bank_id,
            beneficiary_bank_id: data.beneficiary_bank_id,
            notes: data.notes
          }}
        >
          <Row gutter={[24, 16]}>
            <Col xs={24} md={12}>
              <Form.Item label={intl.formatMessage({ id: 'settlement_SenderBank' })}>
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectSenderBank' })}
                  size="large"
                  value={selectedSenderBankId}
                  onChange={async (value) => {
                    setSelectedSenderBankId(value);
                    await loadBankAccountsFiltered('sender', data.sender_id, value);
                    // Reset current account selection
                    form.setFieldsValue({ sender_bank_id: undefined });
                    const b = (senderBankNames || []).find(x => x.bank_id === value);
                    onDataChange({ 
                      ...data, 
                      sender_selected_bank_id: value, 
                      sender_bank_id: null,
                      sender_bank_name: b ? (b.bank_name_en || b.bank_name_ar) : undefined
                    });
                  }}
                  optionFilterProp="children"
                >
                  {(senderBankNames || []).map((b) => (
                    <Option key={b.bank_id} value={b.bank_id}>
                      {b.bank_name_en || b.bank_name_ar}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="sender_bank_id"
                label={intl.formatMessage({ id: 'settlement_BankAccount' })}
              >
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectSenderBankAccount' })}
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  onChange={(value) => {
                    // Find the selected account to extract its bank_id and build display
                    const acc = (senderBanks || []).find(a => a.id === value);
                    const updatedData = { 
                      ...data, 
                      sender_bank_id: value, 
                      sender_selected_bank_id: acc?.bank_id,
                      sender_bank_display: acc ? formatBankOption(acc) : undefined
                    };
                    onDataChange(updatedData);
                    // console.debug('Sender bank selected:', value);
                  }}
                >
                  {(senderBanks || []).map((bank) => (
                    <Option key={bank.id} value={bank.id}>
                      {formatBankOption(bank)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item label={intl.formatMessage({ id: 'settlement_BeneficiaryBank' })}>
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectBeneficiaryBank' })}
                  size="large"
                  value={selectedBeneficiaryBankId}
                  onChange={async (value) => {
                    setSelectedBeneficiaryBankId(value);
                    await loadBankAccountsFiltered('beneficiary', data.beneficiary_id, value);
                    // Reset current account selection
                    form.setFieldsValue({ beneficiary_bank_id: undefined });
                    const b = (beneficiaryBankNames || []).find(x => x.bank_id === value);
                    onDataChange({ 
                      ...data, 
                      beneficiary_selected_bank_id: value, 
                      beneficiary_bank_id: null,
                      beneficiary_bank_name: b ? (b.bank_name_en || b.bank_name_ar) : undefined
                    });
                  }}
                  optionFilterProp="children"
                >
                  {(beneficiaryBankNames || []).map((b) => (
                    <Option key={b.bank_id} value={b.bank_id}>
                      {b.bank_name_en || b.bank_name_ar}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="beneficiary_bank_id"
                label={intl.formatMessage({ id: 'settlement_BankAccount' })}
              >
                <Select
                  placeholder={intl.formatMessage({ id: 'settlement_SelectBeneficiaryBankAccount' })}
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  onChange={(value) => {
                    // Find the selected account to extract its bank_id and build display
                    const acc = (beneficiaryBanks || []).find(a => a.id === value);
                    const updatedData = { 
                      ...data, 
                      beneficiary_bank_id: value, 
                      beneficiary_selected_bank_id: acc?.bank_id,
                      beneficiary_bank_display: acc ? formatBankOption(acc) : undefined
                    };
                    onDataChange(updatedData);
                    // console.debug('Beneficiary bank selected:', value);
                  }}
                >
                  {(beneficiaryBanks || []).map((bank) => (
                    <Option key={bank.id} value={bank.id}>
                      {formatBankOption(bank)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                name="notes"
                label={
                  <span>
                    <FileTextOutlined /> {intl.formatMessage({ id: 'settlement_AdditionalNotes' })}
                  </span>
                }
              >
                <TextArea
                  rows={4}
                  placeholder={intl.formatMessage({ id: 'settlement_OptionalNotesPlaceholder' })}
                  maxLength={500}
                  showCount
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {/** Navigation controls are handled by the parent wizard footer */}
      </Card>
    </div>
  );
};

export default Step4BankTransfer;
